import { SxProps, Theme } from '@mui/material';

export const kitTableRowSX: SxProps<Theme> = {
	borderTop: '1px solid rgba(224, 224, 224, 1)',
};
